export const countriesWithParcelShopsInDBList = [
  {
    alpha2: "AT",
    name: "Austria"
  },
  {
    alpha2: "BE",
    name: "Belgium"
  },
  {
    alpha2: "DK",
    name: "Denmark"
  },
  {
    alpha2: "DE",
    name: "Germany"
  },
  {
    alpha2: "IE",
    name: "Ireland"
  },
  {
    alpha2: "LU",
    name: "Luxembourg"
  },
  {
    alpha2: "NL",
    name: "Netherlands"
  },
  {
    alpha2: "PL",
    name: "Poland"
  },
  {
    alpha2: "PT",
    name: "Portugal"
  },
  {
    alpha2: "ES",
    name: "Spain"
  },
  {
    alpha2: "LT",
    name: "Lithuania"
  },
  {
    alpha2: "FI",
    name: "Finland"
  },
  {
    alpha2: "IT",
    name: "Italy"
  },
  {
    alpha2: "FR",
    name: "France"
  },
  {
    alpha2: "SE",
    name: "Sweden"
  }
]

export function countryHasParcelShops (countryCode) {

  if (countriesWithParcelShopsInDBList.find(e => e.alpha2 === countryCode)) {
    return true;
  }
    return false;
}



// WEBPACK FOOTER //
// ./static/countriesWithParcelShops.js